import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center'
  },
  main: {
    background: theme.palette.grey[200],
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
    width: '50%',
    [theme.breakpoints.down('sm')]: {
      width: '80%'
    }
  },
  part: { padding: theme.spacing(2) },
  btnContainer: { display: 'flex', justifyContent: 'center', marginTop: 4 },
  btn: { margin: 16 },
  greyText: { fontWeight: 500, color: theme.palette.grey[600] },
  blackText: { fontWeight: 500, color: theme.palette.text.primary },
  redText: { fontWeight: 500, color: theme.palette.primary.main },
  whiteText: {
    fontWeight: 500,
    color: theme.palette.primary.contrastText,
    fontSize: 16
  },
  title: {
    fontSize: 20,
    color: theme.palette.text.primary,
    fontWeight: 500
  },
  subTitle: {
    fontSize: 16,
    color: theme.palette.text.primary,
    fontWeight: 500
  },
  text: { fontWeight: 500, color: theme.palette.text.primary },
  textRow: { display: 'flex', gap: 4 },
  textRowChip: {
    display: 'flex',
    gap: 4,
    background: theme.palette.grey[200],
    width: 'fit-content',
    padding: 4,
    borderRadius: 6
  },
  paymentDetails: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginTop: 16
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    padding: 16,
    background: theme.palette.grey[200],
    marginTop: 8
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '8px 0',
    padding: theme.spacing(0, 1.5)
  },
  header: {
    display: 'flex',
    width: '100%',
    borderRadius: 8,
    marginBottom: 16,
    background: theme.palette.background.default,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  },
  img: {
    width: '155px',
    height: '150px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: '100%'
    }
  },
  right: {
    display: 'grid',
    gridTemplateRows: '1fr 1fr',
    padding: 8,
    width: '100%',
    border: `1px solid ${theme.palette.grey[300]}`,
    borderLeft: 'none',
    [theme.breakpoints.down('sm')]: {
      gridTemplateRows: '1fr'
    }
  },
  headerRow: {
    display: 'grid',
    gridTemplateColumns: '2fr 1.5fr',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '2fr'
    }
  },
  date: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: 8,
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'flex-start'
    }
  },
  wallet: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end'
  },
  blueText: { color: theme.palette.info.main, fontWeight: 500 },
  redirect: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end'
  },
  icon: {
    fontSize: 8,
    color: theme.palette.info.main,
    '& svg': { fontSize: '10px' }
  },
  transaction: {
    display: 'flex',
    justifyContent: 'flex-start',
    gap: 6,
    width: '100%',
    padding: 16,
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 8,
    margin: '16px 0',
    background: theme.palette.background.default
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: theme.spacing(1),
    gap: 4,
    borderLeft: '2px solid #ccc'
  },
  greyTex: { fontWeight: 500, color: theme.palette.grey[600] },
  summary: {
    border: `1px solid ${theme.palette.grey[300]}`,
    margin: '16px 0',
    borderRadius: 8,
    background: theme.palette.background.default,
    padding: '8px'
  },
  greenText: {
    color: theme.palette.secondary.main,
    fontWeight: 600
  },
  darkText: { fontWeight: 600, color: theme.palette.grey[800] },
  divider: { margin: '8px 0' }
}))
